import React from 'react';
export const PillTag = ({ label }) => (<span className="inline-flex items-center rounded-full border px-3 py-1 text-[11px] font-medium">
        <span className="mr-2 h-1.5 w-1.5 rounded-full bg-primary"/>
        {label}
    </span>);
